

export const userKeys = {
  all: ['user'] as const,
};

export const invalidateUserQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: userKeys.all });
};
